import { modeStore } from "../stores/mode";
import { get } from "svelte/store";
import ProgressWS from "./progressWS";
import DummyProgressWS from "./dummyProgressWS";
import type { ProgressWSOptions, ProgressWSInterface } from "./progressWSInterface";

export const getWS = ({ onStatusUpdate, jwt, internalProcessKey }: ProgressWSOptions): ProgressWSInterface => {
  return get(modeStore).mode === "demo"
    ? new DummyProgressWS({ onStatusUpdate, jwt, internalProcessKey })
    : new ProgressWS({ onStatusUpdate, jwt, internalProcessKey });
};
